import { render, staticRenderFns } from "./Userportrait.vue?vue&type=template&id=921d63e8&scoped=true"
import script from "./Userportrait.vue?vue&type=script&lang=js"
export * from "./Userportrait.vue?vue&type=script&lang=js"
import style0 from "./Userportrait.vue?vue&type=style&index=0&id=921d63e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921d63e8",
  null
  
)

export default component.exports